import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrgRootComponent } from './components/org-root/org-root.component';
import { ListOrgComponent } from './components/list-org/list-org.component';
import { AddOrgComponent } from './components/add-org/add-org.component';
import { EditOrgComponent } from './components/edit-org/edit-org.component';
import { ViewOrgComponent } from './components/view-org/view-org.component';

const routes: Routes = [
  {
    path: "",
    component: OrgRootComponent,
    children: [
      {
        path: "",
        component: ListOrgComponent
      },
      {
        path: "add",
        component: AddOrgComponent
      },
      {
        path: "update",
        component: EditOrgComponent
      },
      {
        path: "update/:id",
        component: EditOrgComponent
      },
      {
        path: "view/:id",
        component: ViewOrgComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrganizationRoutingModule { }
